import { render, staticRenderFns } from "./CreateTintCategory.vue?vue&type=template&id=191be814&"
import script from "./CreateTintCategory.vue?vue&type=script&lang=js&"
export * from "./CreateTintCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports